import { Injectable, inject } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginResponse } from '../models/user.model';
import { Router } from '@angular/router';
import { Authorizer, Authorizers, ListenerRules } from '../models/erugateway.model';
import { AuthorizerPayload } from '../components/erugateway/erugateway-authform/erugateway-authform.component';
import { RuleTypePayload } from '../components/erugateway/erugateway-list-form/erugateway-list-form';

@Injectable({
  providedIn: 'root'
})
export class EruGatewayService {
  private router = inject(Router);
  
  constructor(private httpService: HttpService) {}

  fetchConfig(url: string, project_name: string): Observable<any> {
    return this.httpService.get<any>(`${url}/store/config`).pipe(
      map(response => {
        console.log('Raw fetchConfig response:', response);
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Projects not found'));
      })
    );
  }
  
  fetchAuthorizerlist(url: string): Observable<{
    authorizers: any;
    project: Authorizers
  }> {
    return this.httpService.get<any>(
      `${url}/store/authorizer/list`
    ).pipe(
      map(response => {
        if (response && response.authorizers) {
          return {
            authorizers: response.authorizers,
            project: response.authorizers
          };
        } else {
          return {
            authorizers: {},
            project: { authorizers: new Map() }
          };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Api Error:', error);
        return throwError(() => new Error(error.error?.error || 'Projects not found'));
      })
    );
  }

  fetchListenerRulelist(url: string): Observable<{
    project: ListenerRules
  }> {
    return this.httpService.get<any>(
      `${url}/store/listenerrule/list`
    ).pipe(
      map(response => {
        if (response && response.listener_rules) {
          return {
            project: { listener_rules: response.listener_rules }
          };
        } else {
          return {
            project: { listener_rules: new Map() }
          };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Api Error:', error);
        return throwError(() => new Error(error.error?.error || 'Projects not found'));
      })
    );
  }

  saveAuthorizer(url:string,project_name:string,authForm:AuthorizerPayload):Observable<any>{
    return this.httpService.post<any>(
      `${url}/store/authorizer/save`,
      authForm
    ).pipe(
      tap(response=>console.log('Authorizer saved:',response)),
      catchError((error:HttpErrorResponse)=>{
        console.error('API Error');
        return throwError(()=>new Error(error.error?.error||'Failed to save Authorizer'));
      })
    );
  }

  deleteAuthorizer(url:string,project_name:string,authForm:Authorizer):Observable<any>{
    return this.httpService.delete<any>(
    `${url}/store/authorizer/remove/${authForm.authorizer_name}`,
    ).pipe(
    catchError((error:HttpErrorResponse)=>{
      console.log('API Error:',error);
      return throwError(()=>new Error(error.error?.error||'Failed to delete Auth'))
    })
  )
}

saveListenerRule(url:string,project_name:string,authForm:RuleTypePayload):Observable<any>{
  return this.httpService.post<any>(
    `${url}/store/listenerrule/save`,
    authForm
  ).pipe(
    tap(response=>console.log('Listener Rule saved:',response)),
    catchError((error:HttpErrorResponse)=>{
      console.error('API Error');
      return throwError(()=>new Error(error.error?.error||'Failed to save Listener Rule'));
    })
  );
}

deleteListenerRule(baseUrl: string, projectName: string, listenerRule: RuleTypePayload): Observable<void> {
  return this.httpService.delete<void>(`${baseUrl}/store/listenerrule/remove/${listenerRule.rule_name}`)
  .pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('API Error:', error);
      return throwError(() => new Error(error.error?.error || 'Failed to delete Listener Rule'));
    })
  );
}

  
  loginWithUserPassword(url: string, username: string, password: string): Observable<LoginResponse> {
    return this.httpService.post<LoginResponse>(
      url,
      { username, password }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Login failed'));
      })
    );
  }
}